import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.85355 5.35353C10.0488 5.15827 10.0488 4.84169 9.85355 4.64642L5.85355 0.646423L5.14645 1.35353L8.29289 4.49998L4.37112e-08 4.49998L0 5.49998L8.29289 5.49998L5.14645 8.64642L5.85355 9.35353L9.85355 5.35353Z\" fill=\"black\" fill-opacity=\"0.87\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol